import React, {useEffect} from 'react';
import {LandingMenu} from "../../components/common/LandingMenu";
import LoginTabs from "../../components/login-register/LoginTabs";
import {Link, useNavigate} from "react-router-dom";
import jwtDecode from "jwt-decode";
import {Typography} from "@material-tailwind/react";
import {PhoneIcon} from "@heroicons/react/16/solid";
import {EnvelopeIcon, GlobeAltIcon} from "@heroicons/react/24/outline";

import { motion } from 'framer-motion';

function LoginPage() {

    const currentYear = new Date().getFullYear();

    const navigate = useNavigate();

    useEffect(() => {
        const scrollPosition = sessionStorage.getItem('scrollPosition');
        if (scrollPosition) {
            window.scrollTo(0, parseInt(scrollPosition));
            sessionStorage.removeItem('scrollPosition');
        } else {
            window.scrollTo(0, 0);
        }
    }, []);

    useEffect(() => {
        const token = localStorage.getItem('token');

        if (token) {
            try {
                const decoded = jwtDecode(token);
                const expiration = decoded.exp;  // Token expiration time
                const now = Date.now() / 1000;  // Current time in seconds

                // Ako token nije istekao, preusmeri na home
                if (expiration > now) {
                    navigate('/home');
                } else {
                    console.error('Token has expired');
                    // Ovdje možeš izvršiti akciju poput izlogovanja korisnika ako je token istekao
                }
            } catch (error) {
                console.error('Error decoding token:', error);
                // Možda želiš da izloguješ korisnika ili prikažeš poruku o grešci
            }
        } else {
            console.error('Token not found');
            // Možda želiš da izloguješ korisnika ili prikažeš poruku da je token nedostupan
        }
    }, [navigate]);

    return (
        <>
            <div className="overflow-hidden">
                <div className="flex justify-center w-full min-h-screen bg-gray-50 flex-col">
                    <div className="h-5 bg-gray-50"></div>

                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                        {/* Levi krug */}
                        <div className="absolute w-[35vw] h-[35vw] bg-blue-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob"
                             style={{ top: '40%', left: '30%', transform: 'translate(-80%, -50%)' }}></div>
                        {/* Desni krug */}
                        <div className="absolute w-[35vw] h-[35vw] bg-red-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob animation-delay-2000"
                             style={{ top: '50%', left: '70%', transform: 'translate(-20%, -50%)' }}></div>
                        {/* Donji krug */}
                        <div className="absolute w-[35vw] h-[35vw] bg-blue-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob animation-delay-4000"
                             style={{ top: '60%', left: '60%', transform: 'translate(-50%, 10%)' }}></div>
                    </div>

                    <div className="mx-2">
                        <LandingMenu />

                        <motion.div
                            initial={{ opacity: 0, y: -100 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.75 }}
                        >

                        <div className="h-6 bg-grayblue-50"></div>

                        <div className="flex justify-center w-full min-h-screen bg-gray-50">
                            <div className="mt-2 flex justify-center w-full max-w-2xl">
                                <div className="mx-2 w-full">
                                    <LoginTabs />
                                </div>
                            </div>
                        </div>

                        <div className="flex gap-4 mt-24 mb-4">
                            <footer className="relative w-full">
                                <div className="mx-auto w-full max-w-7xl px-8">
                                    <div className="mx-auto grid w-full grid-cols-1 gap-8 py-12 md:grid-cols-2 lg:grid-cols-4">

                                        <div className="w-full flex items-center justify-start lg:justify-center">
                                            <img
                                                src="/transparent logo.png"
                                                alt="Smart Service System Logo"
                                                className="h-24 w-auto"
                                            />
                                        </div>

                                        <div className="w-full">
                                            <Typography variant="small" className="mb-4 font-bold uppercase text-gray-900">
                                                Navigacija
                                            </Typography>
                                            <ul className="space-y-1">
                                                <Link to="/">
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">Početna strana</span>
                                                    </Typography>
                                                </Link>
                                                <Link to="/o_nama">
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">O nama</span>
                                                    </Typography>
                                                </Link>
                                                <Link to="/saveti">
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">Saveti</span>
                                                    </Typography>
                                                </Link>
                                                <Link to="/kontakt">
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">Kontakt</span>
                                                    </Typography>
                                                </Link>
                                            </ul>
                                        </div>

                                        <div className="w-full">
                                            <Typography variant="small" className="mb-4 font-bold uppercase text-gray-900">
                                                Kontakt
                                            </Typography>
                                            <ul className="space-y-1">
                                                <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                    <span className="inline-block py-1 pr-2">Za sva Vaša pitanja</span>
                                                </Typography>
                                                <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                    <span className="inline-block py-1 pr-2">stojimo na raspolaganju</span>
                                                </Typography>
                                                <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                    <span className="inline-block py-1 pr-2">svakog radnog dana</span>
                                                </Typography>
                                                <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                    <span className="inline-block py-1 pr-2">od 12-14h</span>
                                                </Typography>
                                            </ul>
                                        </div>

                                        <div className="w-full">
                                            <div className="flex items-center space-x-4 mb-4">
                                                <GlobeAltIcon className="h-5 w-5 text-gray-900" />
                                                <EnvelopeIcon className="h-5 w-5 text-gray-900" />
                                                <PhoneIcon className="h-5 w-5 text-gray-900" />
                                            </div>
                                            <ul className="space-y-1">
                                                <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                    <span className="inline-block py-1 pr-2">www.smartservicesystem.rs</span>
                                                </Typography>
                                                <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                    <span className="inline-block py-1 pr-2">info@smartservicesystem.rs</span>
                                                </Typography>
                                                <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                    <span className="inline-block py-1 pr-2">+381 61 528 00 18</span>
                                                </Typography>
                                                <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                    <a  href="/Politika%20privatnosti.pdf" target="_blank" rel="noopener noreferrer" className="inline-block py-1 pr-2">Politika privatnosti</a>
                                                </Typography>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="flex w-full flex-col items-center justify-center border-t border-blue-gray-50 py-4 md:flex-row md:justify-between">
                                        <Typography
                                            variant="small"
                                            className="mb-4 text-center font-normal text-blue-gray-900 md:mb-0"
                                        >
                                            &copy; {currentYear} <a href="https://smartservicesystem.rs/">Smart Service System</a>. Sva
                                            prava zadržana.
                                        </Typography>
                                    </div>
                                </div>
                            </footer>
                        </div>
                        </motion.div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LoginPage;